__turbopack_context__.v({
  "childrenContainer": "ImageModal-module__KX_nLa__childrenContainer",
  "root": "ImageModal-module__KX_nLa__root",
  "stickyContainer": "ImageModal-module__KX_nLa__stickyContainer",
});
